/* eslint-disable no-unused-vars */
export enum PaymentStatusEnum {
  Created,
  Processing,

  Failed,
  Success,
}
